import { alpha } from "@commonlibs";
import { SimpleDataPoints as ISimpleDataPoints } from "../SimpleAreaChart.types";
import { AreaChartProps } from "../../AreaChart.types";

export class SimpleDataPoints implements ISimpleDataPoints {
    values: number[];
    color: string;

    constructor(values: number[], color: string) {
        this.values = values;
        this.color = color;
    }

    static toDataset({ color, values }: ISimpleDataPoints): AreaChartProps["data"]["datasets"][0] {
        return {
            fill: true,
            data: values.map((value) => value),
            borderColor: color,
            borderWidth: 4,
            backgroundColor: alpha(color, 0.12),
            pointRadius: 1,
            pointBorderColor: "transparent",
        };
    }
}
